function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#9e9e9e",
  d: "M11.6 10.4a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zm0 4.8a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zM8 11a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm3.6 8.4a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zM8 15.8a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm3.6-7.2A.6.6 0 1 0 11 8a.594.594 0 0 0 .6.6zm4.8 1.8a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2zm0-1.8a.6.6 0 1 0-.6-.6.594.594 0 0 0 .6.6zm3.6 7.2a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm0-4.8a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm-6-9a12 12 0 1 0 12 12A12 12 0 0 0 14 2zm0 21.6a9.6 9.6 0 1 1 9.6-9.6 9.6 9.6 0 0 1-9.6 9.6zm2.4-4.2a.6.6 0 1 0 .6.6.594.594 0 0 0-.6-.6zm0-4.2a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2z",
  transform: "translate(-2 -2)"
});

function SvgIconHeatmap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeatmap);
export default __webpack_public_path__ + "static/media/icon-heatmap.ddad1b28.svg";
export { ForwardRef as ReactComponent };